import { useMutation } from '@tanstack/react-query';
import { App } from 'antd';
import { handleError } from 'api';
import {
  BookingApiService,
  recurringBookingsQueryKeys,
} from 'features/bookings';
import i18n from 'locales/i18n';
import { queryClient } from 'providers';

const { cancelRecurringBooking } = BookingApiService();

export const useCancelRecurringBooking = () => {
  const { message } = App.useApp();

  return useMutation(
    (id: string) => {
      return cancelRecurringBooking(id);
    },
    {
      onError: (error) => {
        const uiMessage = handleError(error);

        message.error(uiMessage);
      },
      onSuccess: (_, id) => {
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: recurringBookingsQueryKeys.lists(),
          }),
          queryClient.invalidateQueries({
            queryKey: recurringBookingsQueryKeys.detail(id),
          }),
        ]);

        message.success(i18n.t('bookings.details.successfulCancellation'));
      },
    },
  );
};
